import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-5 py-2"
}

import { ref, watch } from 'vue'
import { debounce } from 'lodash'
import { TextFieldDensity } from '../helpers'

interface Props {
  label: string
  items: unknown[]
  itemTitle: string
  modelValue?: { [itemTitle: string]: unknown }
  isLoadMoreItems?: boolean
  debounceForLoadMore?: number
  noDataText?: string
  density?: TextFieldDensity
  errorMessages?: string | readonly string[]
  readonly?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VAutocompleteServer',
  props: {
    label: {},
    items: {},
    itemTitle: {},
    modelValue: {},
    isLoadMoreItems: { type: Boolean, default: true },
    debounceForLoadMore: { default: 300 },
    noDataText: { default: 'Данных нет' },
    density: {},
    errorMessages: {},
    readonly: { type: Boolean, default: false }
  },
  emits: ['loadMore', 'update:model-value', 'update:search-value'],
  setup(__props: any, { emit }) {

const props = __props;




const search = ref('')

const endIntersect = (isIntersecting: boolean) => {
  if (isIntersecting) emit('loadMore', search.value)
}

watch(
  () => search.value,
  debounce(val => {
    if (val && val !== props.modelValue?.[props.itemTitle]) {
      emit('update:search-value', val)
    }
    if (!val && !props.modelValue) {
      emit('update:search-value', val)
    }
  }, props.debounceForLoadMore),
)

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, {
    search: search.value,
    "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
    "model-value": _ctx.modelValue,
    items: _ctx.items,
    "item-title": _ctx.itemTitle,
    label: _ctx.label,
    density: _ctx.density,
    "error-messages": _ctx.errorMessages,
    "no-filter": "",
    "return-object": "",
    "open-on-clear": "",
    clearable: !_ctx.readonly,
    readonly: _ctx.readonly,
    "menu-props": { maxWidth: 0 },
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:model-value', $event)))
  }, {
    "append-item": _withCtx(() => [
      (_ctx.isLoadMoreItems)
        ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            variant: "text",
            width: "100%",
            loading: ""
          }, null, 512)), [
            [_directive_intersect, endIntersect]
          ])
        : _createCommentVNode("", true)
    ]),
    "no-data": _withCtx(() => [
      (!_ctx.isLoadMoreItems)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.noDataText), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["search", "model-value", "items", "item-title", "label", "density", "error-messages", "clearable", "readonly"]))
}
}

})